const QUESTION_NAMES = {
  FINANCIAL_CONTROL: 'financialControl',
  HOUSEHOLD: 'household',
  AVERAGE_INCOME: 'averageIncome',
  HANDLE_UNEXPECTED_INCOME: 'handleUnexpectedIncome',
  HANDLE_UNEXPECTED_EXPENSE: 'handleUnexpectedExpense',
  IS_INCOME_FIXED: 'isIncomeFixed',
  JOB_TO_BE_DONE: 'jobToBeDone',
};

const ANSWER_OPTIONS = {
  [QUESTION_NAMES.FINANCIAL_CONTROL]: {
    FULL_CONTROL: 'fullControl',
    SOME_CONTROL: 'someControl',
    NO_CONTROL: 'noControl',
  },
  [QUESTION_NAMES.HOUSEHOLD]: {
    JUST_ME: 'justMe',
    PARTNER: 'partner',
    KIDS: 'kids',
  },
  [QUESTION_NAMES.AVERAGE_INCOME]: {
    OVER_BAR: 'overBar',
    UNDER_BAR: 'underBar',
    NONE: 'none',
  },
  [QUESTION_NAMES.HANDLE_UNEXPECTED_INCOME]: {
    COVER_LOANS: 'coverLoans',
    SAVINGS: 'savings',
    BALANCE: 'balance',
  },
  [QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE]: {
    CALM: 'calm',
    STRESSED: 'stressed',
    ANXIOUS: 'anxious',
  },
  [QUESTION_NAMES.IS_INCOME_FIXED]: {
    FIXED: 'fixed',
    SOMEWHAT_FIXED: 'somewhatFixed',
    NOT_FIXED: 'notFixed',
  },
  [QUESTION_NAMES.JOB_TO_BE_DONE]: {
    NO_OVERDRAFT: 'noOverdraft',
    REDUCE_EXPENSES: 'reduceExpenses',
    START_SAVING: 'startSaving',
  },
};

export default {
  QUESTION_NAMES,
  ANSWER_OPTIONS,
};
